import React from 'react';

/**
 * Submit button with loading state for auth forms
 * Provides consistent styling across all auth pages
 * 
 * @param {Object} props
 * @param {boolean} props.loading - Whether form is submitting
 * @param {string} props.loadingText - Text to show while loading
 * @param {string} props.children - Button text when not loading
 * @param {boolean} props.disabled - Whether button is disabled
 * @param {string} props.type - Button type (default: 'submit')
 * @param {string} props.className - Additional classes
 */
const AuthSubmitButton = ({
  loading,
  loadingText = 'Loading...',
  children,
  disabled = false,
  type = 'submit',
  className = ''
}) => {
  return (
    <button
      type={type}
      disabled={loading || disabled}
      className={`
        w-full bg-gradient-to-r from-blue-500 to-indigo-600 
        text-white py-3 px-4 rounded-xl font-medium 
        hover:from-blue-600 hover:to-indigo-700 
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 
        disabled:opacity-50 disabled:cursor-not-allowed 
        transition-all duration-200 shadow-lg
        ${className}
      `}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
          {loadingText}
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default AuthSubmitButton;
